import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTotalBalance } from "../features/balance/totalBalanceSlice";
import numberWithCommas from "../utils/numberWithCommas";

export default function Balance() {
  const { transactions } = useSelector((state) => state.transaction);
  const { balance, loading } = useSelector((state) => state.balance);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchTotalBalance());
  }, [dispatch, transactions]);

  return (
    <div className="top_card">
      <p>Your Current Balance</p>
      <h3>
        {loading ? (
          <div style={{ width: "200px", height:"2.2rem" }} className="loadingStyle"></div>
        ) : (
          <>
            <span>৳</span> <span>{numberWithCommas(balance)}</span>
          </>
        )}
      </h3>
    </div>
  );
}
